import React from "react"
import { Switch, Route } from "react-router-dom"

import styled from "styled-components/macro"

import { PageContainer } from "../../components/Containers"

const Layout = styled.div`
  gap: var(--spacing4);
  display: grid;

  grid-template-columns: 100%;

  @media (min-width: ${(p) => p.theme.breakpoints[2]}px) {
    max-width: 700px;
  }
`

const MainHeader = styled.h1`
  margin: 0 0 var(--spacing3) 0;
  font-size: var(--fs-xl);
  font-weight: bold;
  font-family: var(--ff-serif);
`

const InfoPage = ({ routes }) => {
  return (
    <PageContainer>
      <Layout>
        <div>
          <Switch>
            {routes.map((route) =>
              route.hidden ? null : (
                <Route
                  exact
                  path={route.path}
                  render={() => {
                    const C = route.component
                    return (
                      <>
                        <MainHeader>{route.label}</MainHeader>
                        <C />
                      </>
                    )
                  }}
                  key={route.path}
                />
              )
            )}
          </Switch>
        </div>
      </Layout>
    </PageContainer>
  )
}

export default InfoPage
